// noinspection GraphQLUnresolvedReference

import { gql } from 'graphql-request'

/**
 * Fragmento de campos de articulo
 */
export const ARTICULO_FIELDS_FRAGMENT = gql`
  fragment ArticuloFieldsFragment on Articulo {
    _id
    codigoArticulo
    nombreArticulo
    descripcionArticulo
    claseArticulo
    sinProductoServicio {
      codigoActividad
      codigoProducto
      descripcionProducto
    }
    actividadEconomica {
      codigoCaeb
      descripcion
      tipoActividad
    }
    tipoArticulo {
      codigo
      descripcion
    }
    gestionArticulo
    proveedor {
      codigo
      nombre
    }
    imagen {
      variants {
        thumbnail
        medium
        square
      }
    }
    codigoGrupoUnidadMedida
    grupoUnidadMedida {
      codigoGrupo
      nombreGrupo
      unidadMedidaBase {
        codigoUnidadMedida
      }
    }
    articuloPrecioBase {
      articuloUnidadMedida {
        _id
        codigoUnidadMedida
        nombreUnidadMedida
      }
      monedaPrimaria {
        moneda {
          codigo
          sigla
          descripcion
          tipoCambio
          tipoCambioCompra
        }
        precioBase
        precio
        manual
      }
      monedaAdicional1 {
        moneda {
          codigo
          sigla
          descripcion
          tipoCambio
          tipoCambioCompra
        }
        precioBase
        precio
        manual
      }
      monedaAdicional2 {
        moneda {
          codigo
          sigla
          descripcion
          tipoCambio
          tipoCambioCompra
        }
        precioBase
        precio
        manual
      }
      monedaAdicional3 {
        moneda {
          codigo
          sigla
          descripcion
          tipoCambio
          tipoCambioCompra
        }
        precioBase
        precio
        manual
      }
      cantidadBase
      imagen {
        variants {
          thumbnail
          medium
        }
      }
      descuento {
        fechaInicial
        fechaFinal
        porcentaje
        cantidad {
          nro
          porcentaje
        }
      }
      factorAjuste
      umVenta
      umCompra
      umInventario
    }
    articuloPrecio {
      articuloUnidadMedida {
        _id
        codigoUnidadMedida
        nombreUnidadMedida
      }
      monedaPrimaria {
        moneda {
          codigo
          sigla
          descripcion
          tipoCambio
          tipoCambioCompra
        }
        precioBase
        precio
        delivery
        manual
      }
      monedaAdicional1 {
        moneda {
          codigo
          sigla
          descripcion
          tipoCambio
          tipoCambioCompra
        }
        precioBase
        precio
        manual
      }
      monedaAdicional2 {
        moneda {
          codigo
          sigla
          descripcion
          tipoCambio
          tipoCambioCompra
        }
        precioBase
        precio
        manual
      }
      monedaAdicional3 {
        moneda {
          codigo
          sigla
          descripcion
          tipoCambio
          tipoCambioCompra
        }
        precioBase
        precio
        manual
      }
      cantidadBase
      imagen {
        variants {
          thumbnail
          medium
        }
      }
      descuento {
        fechaInicial
        fechaFinal
        porcentaje
        cantidad {
          nro
          porcentaje
        }
      }
      factorAjuste
      umVenta
      umCompra
      umInventario
    }
    state
    verificarStock
    articuloVenta
    articuloCompra
    articuloInventario
    activo
    inventario {
      totalStock
      totalDisponible
      totalSolicitado
      totalComprometido
      sucursal {
        codigo
        direccion
        telefono
        municipio
      }
      detalle {
        almacen {
          codigoAlmacen
          nombre
          ubicacion
          sucursal {
            codigo
          }
        }
        stock
        comprometido
        solicitado
        disponible
        lotes {
          lote {
            codigoLote
            descripcion
            sucursal {
              codigo
              direccion
            }
            atributo1
            atributo2
            atributo3
            fechaAdmision
            fechaFabricacion
            fechaVencimiento
          }
          stock
          comprometido
          solicitado
          disponible
        }
      }
    }
    complemento
    listaComplemento {
      id
      codigoArticulo
      nombreArticulo
    }
    usucre
    usumod
    createdAt
    updatedAt
  }
`

/**
 * Fragmento de campos de articulo precios
 */
export const ARTICULO_PRECIO_BASE_FRAGMENT = gql`
  fragment ArticuloPrecioBase on ArticuloPrecioBaseListado {
    _id
    articuloPrecioId
    activo
    state
    codigoArticulo
    nombreArticulo
    tipoArticulo {
      codigo
      descripcion
    }
    proveedor {
      codigo
      nombre
      direccion
      correo
    }
    imagen {
      id
    }
    cantidadBase
    articuloUnidadMedida {
      _id
      codigoUnidadMedida
      nombreUnidadMedida
    }
    moneda {
      codigo
      sigla
    }
    precio
    precioBase
    manual

    monedaA1 {
      codigo
      sigla
    }
    precioA1
    precioBaseA1
    manualA1

    monedaA2 {
      codigo
      sigla
    }
    precioA2
    precioBaseA2
    manualA2

    monedaA3 {
      codigo
      sigla
    }
    precioA3
    precioBaseA3
    manualA3
  }
`

/**
 * Fragmento de campos de articulo precios
 */
export const ARTICULO_RESUMIDO_FRAGMENT = gql`
  fragment ArticuloFieldsFragment on Articulo {
    _id
    codigoArticulo
    nombreArticulo
    descripcionArticulo
    tipoArticulo {
      codigo
      descripcion
    }
    claseArticulo
    proveedor {
      codigo
      nombre
    }
    imagen {
      variants {
        thumbnail
        medium
        square
      }
    }
    codigoGrupoUnidadMedida
    articuloPrecioBase {
      articuloUnidadMedida {
        _id
        codigoUnidadMedida
        nombreUnidadMedida
      }
      monedaPrimaria {
        moneda {
          codigo
          sigla
          descripcion
          tipoCambio
          tipoCambioCompra
        }
        precioBase
        precio
        manual
      }
      cantidadBase
      imagen {
        variants {
          thumbnail
          medium
        }
      }
      descuento {
        fechaInicial
        fechaFinal
        porcentaje
        cantidad {
          nro
          porcentaje
        }
      }
      factorAjuste
      umVenta
      umCompra
      umInventario
    }
    verificarStock
    articuloVenta
    articuloCompra
    articuloInventario
    activo
    inventario {
      totalStock
      totalDisponible
      totalSolicitado
      totalComprometido
    }
    state
    usucre
    usumod
    createdAt
    updatedAt
  }
`
